import { makeStyles } from '@material-ui/core/styles';

import { Link as Route } from 'react-router-dom';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Typography from 'components/CncUI/Typography';
import Button from 'components/CncUI/Button';

const useStyles = makeStyles(({ palette, breakpoints }) => ({
  header: {
    textAlign: 'center',
    [breakpoints.up('lg')]: {
      fontSize: 48,
      lineHeight: '56px',
    },
  },
  body: {
    maxWidth: '90%',
    margin: '0 auto',
    [breakpoints.down('sm')]: {
      maxWidth: '100%',
    },
  },
  register: {
    textDecoration: 'none',
  },
  link: {
    color: palette.cncUI.misc.link,
  },
}));

const Welcome = ({ isRegistered = false }) => {
  const classes = useStyles();
  const snippet = ' paystubs and tax document forms';

  const content = isRegistered ? (
    <Typography
      variant="body1"
      size="long"
      className={classes.body}
      id="WelcomeBody"
    >
      Your one-stop-shop to sign in to all your Cast & Crew digital applications
      – simply click on the product name to the right to launch the app. Plus,
      we’ve now made it even easier for production employees to access their
      {snippet}. Click on the tabs above to view your documents. For more crew
      information, please visit our{' '}
      <Link
        target="_blank"
        rel="noopener noreferrer"
        href="https://support.castandcrew.com/kb/mycastcrew-u-s"
        className={classes.link}
      >
        FAQs
      </Link>
      .
    </Typography>
  ) : (
    <Typography
      variant="body1"
      size="long"
      className={classes.body}
      id="WelcomeBody"
    >
      Your one-stop-shop to sign in to all your Cast & Crew digital applications
      – simply click on the product name to the right to launch the app. Plus,
      we’ve now made it even easier for production employees to access their
      {snippet}. Click the link below to validate your production employee
      account. For more information, please visit our{' '}
      <Link
        target="_blank"
        rel="noopener noreferrer"
        href="https://support.castandcrew.com/kb/mycastcrew-u-s"
        className={classes.link}
      >
        FAQs
      </Link>
      .
    </Typography>
  );

  return (
    <Grid container spacing={2} direction="column" alignItems="center">
      <Grid item>
        <Typography variant="h2" className={classes.header} id="WelcomeHeader">
          Welcome to MyCast&Crew
        </Typography>
      </Grid>
      <Grid item>{content}</Grid>
      {!isRegistered && (
        <Grid item>
          <Route to="/register" className={classes.register}>
            <Button tertiary style={{ fontSize: 18 }}>
              Register for Tax documents / Paystubs / Direct Deposits
            </Button>
          </Route>
        </Grid>
      )}
    </Grid>
  );
};

export default Welcome;
